<template>
  <img src="../../../assets/img/avatars/avatar3.jpg" alt="avatar3">
</template>
